import { render, staticRenderFns } from "./TabModal.vue?vue&type=template&id=50b43784&"
import script from "./TabModal.vue?vue&type=script&lang=js&"
export * from "./TabModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports